export const MAXIMUM_FILE_LIMIT = 21;

// 외부문서는 from / to의 제한이 명확하지 않아서, UTC시작 년도인 1972년부터 2099년까지로 제한
export const EXTERNAL_DOCUMENT_DEFAULT_FROM_YEAR = 1972;
export const EXTERNAL_DOCUMENT_DEFAULT_TO_YEAR = 2099;
